module.exports = __webpack_public_path__ + "img/index_fx.aa2eb47a.png";